import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { DocumentVersion } from './useDocumentVersions';

export function useUpdateDocumentVersion(documentId?: string) {
  const queryClient = useQueryClient();

  const setPrimaryVersion = useCallback(
    (versionId: string) => {
      if (!documentId) return;

      queryClient.setQueriesData<{ data: DocumentVersion[] }>(
        {
          predicate: query =>
            query.queryKey.some(
              key => typeof key === 'string' && key.includes(`documents/${documentId}/versions`),
            ),
        },
        old => {
          if (!old?.data) return old;
          return {
            ...old,
            data: old.data.map(v => ({
              ...v,
              isPrimary: v.id === versionId,
            })),
          };
        },
      );
    },
    [queryClient, documentId],
  );

  return { setPrimaryVersion };
}
